// This is data we use to build url if a hard link is not provided in env.
const { protocol, hostname } = window.location;
const apiPath = '/wp-json/jwt-auth';

export const API_URL = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : `${protocol}//${hostname}${apiPath}`;
